"use client";

import { c as _c } from "react/compiler-runtime";
import { useIntl } from "react-intl";
import FormItem from "forms/fields/FormItem";
import { extractPersonalFields } from "forms/helpers/extractPersonalData";
import type { FormControlType } from "types/formType";
import { predefinedFields } from "types/predefinedFields";
import type { IFormInputs } from "types/uiSchema";
import EmailInfoTooltip from "ui/EmailInfoTooltip/EmailInfoTooltip";
import { Fieldset } from "ui/Fieldset";
import { FormField } from "uiShadcn/form";
import { Input } from "uiShadcn/input";
interface PersonalDataProps {
  control: FormControlType;
  uiData: IFormInputs;
}
export default function PersonalData(t0) {
  const $ = _c(37);
  const {
    control,
    uiData
  } = t0;
  const {
    formatMessage
  } = useIntl();
  let fields;
  let t1;
  if ($[0] !== uiData?.elements) {
    fields = extractPersonalFields(uiData?.elements ?? []);
    t1 = fields?.phone?.required?.includes("true");
    $[0] = uiData?.elements;
    $[1] = fields;
    $[2] = t1;
  } else {
    fields = $[1];
    t1 = $[2];
  }
  const isPhoneRequired = t1;
  const repeatEmail = fields?.email?.["x-json-schema-double-email-verification-required"];
  let t2;
  if ($[3] !== formatMessage) {
    t2 = formatMessage({
      id: "personal_data"
    });
    $[3] = formatMessage;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== formatMessage) {
    t3 = t4 => {
      const {
        field
      } = t4;
      return <FormItem label={formatMessage({
        id: "firstname"
      })} required={true}><Input {...field} type="text" dataTestId={predefinedFields.firstName} placeholder={formatMessage({
          id: "enter"
        })} required={true} /></FormItem>;
    };
    $[5] = formatMessage;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== control || $[8] !== t3) {
    t4 = <FormField control={control} name={predefinedFields.firstName} render={t3} />;
    $[7] = control;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== formatMessage) {
    t5 = t6 => {
      const {
        field: field_0
      } = t6;
      return <FormItem label={formatMessage({
        id: "surname"
      })} required={true}><Input {...field_0} type="text" dataTestId={predefinedFields.lastName} placeholder={formatMessage({
          id: "enter"
        })} required={true} /></FormItem>;
    };
    $[10] = formatMessage;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== control || $[13] !== t5) {
    t6 = <FormField control={control} name={predefinedFields.lastName} render={t5} />;
    $[12] = control;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== formatMessage) {
    t7 = t8 => {
      const {
        field: field_1
      } = t8;
      return <FormItem label={formatMessage({
        id: "email"
      })} extraContent={<EmailInfoTooltip />} required={true}><Input {...field_1} type="email" dataTestId={predefinedFields.email} placeholder={formatMessage({
          id: "enter"
        })} required={true} /></FormItem>;
    };
    $[15] = formatMessage;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== control || $[18] !== t7) {
    t8 = <FormField control={control} name={predefinedFields.email} render={t7} />;
    $[17] = control;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== control || $[21] !== formatMessage || $[22] !== repeatEmail) {
    t9 = repeatEmail && <FormField control={control} name={predefinedFields.repeatEmail} render={t10 => {
      const {
        field: field_2
      } = t10;
      return <FormItem label={formatMessage({
        id: "email_repeat"
      })} required={true}><Input {...field_2} type="email" dataTestId={predefinedFields.repeatEmail} placeholder={formatMessage({
          id: "enter"
        })} value={field_2.value as string} autoComplete="off" required={true} /></FormItem>;
    }} />;
    $[20] = control;
    $[21] = formatMessage;
    $[22] = repeatEmail;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== formatMessage || $[25] !== isPhoneRequired) {
    t10 = t11 => {
      const {
        field: field_3
      } = t11;
      return <FormItem label={formatMessage({
        id: "phone"
      })} required={isPhoneRequired}><Input {...field_3} type="phone" value={field_3.value as string} dataTestId={predefinedFields.phone} placeholder={formatMessage({
          id: "enter"
        })} onChange={e => {
          const {
            value
          } = e.target;
          field_3.onChange({
            target: {
              value: value === "" ? null : value
            }
          });
        }} required={isPhoneRequired} /></FormItem>;
    };
    $[24] = formatMessage;
    $[25] = isPhoneRequired;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== control || $[28] !== t10) {
    t11 = <FormField control={control} name={predefinedFields.phone} render={t10} />;
    $[27] = control;
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t11 || $[31] !== t2 || $[32] !== t4 || $[33] !== t6 || $[34] !== t8 || $[35] !== t9) {
    t12 = <Fieldset title={t2}>{t4}{t6}{t8}{t9}{t11}</Fieldset>;
    $[30] = t11;
    $[31] = t2;
    $[32] = t4;
    $[33] = t6;
    $[34] = t8;
    $[35] = t9;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
}